import type { Member } from "../types";

export function normalizeMember(user: Partial<Member>): Member {
  const normalizedUser = user as Partial<Member> & {
    isIfa?: boolean;
  };

  return {
    uid: normalizedUser.uid as number,
    name: normalizedUser.name ?? "",
    empNo: normalizedUser.empNo ?? "",
    jobName: normalizedUser.jobName ?? "",
    rankName: normalizedUser.rankName ?? "",
    email: normalizedUser.email,
    teamId: normalizedUser.teamId,
    teamName: normalizedUser.teamName,
    iaCode: normalizedUser.iaCode,
    isIFA: normalizedUser.isIFA ?? normalizedUser.isIfa,
    personnelType: normalizedUser.personnelType,
    employmentStatus: normalizedUser.employmentStatus,
    status: normalizedUser.status,
  };
}
